import 'core-js/stable';
import 'whatwg-fetch';
import 'matchmedia-polyfill';
import 'matchMedia-polyfill/matchMedia.addListener';
import './lib/rAF';
import Stickyfill from 'stickyfilljs';
import 'svgxuse';
import 'classlist-polyfill';
import 'element-closest/browser';
import 'picturefill';
import 'intersection-observer';

window.Stickyfill = window.Stickyfill || Stickyfill;
